document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.offer-item__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.offer-item').classList.toggle('is-open');
    });
  });

  document.querySelectorAll('[data-view-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const block = btn.closest('.offers-block');
      const extraItems = block.querySelectorAll('.offer-item--extra');
      const isExpanded = btn.classList.toggle('is-expanded');

      extraItems.forEach(function (item) {
        item.hidden = !isExpanded;
      });

      btn.textContent = isExpanded ? btn.dataset.lessLabel : btn.dataset.moreLabel;
    });
  });

  document.querySelectorAll('.offer-item__code, .offer-item__copy').forEach(function (el) {
    el.addEventListener('click', function () {
      const item = el.closest('.offer-item');
      const code = item.querySelector('.offer-item__code').dataset.code;
      navigator.clipboard.writeText(code).then(function () {
        const label = item.querySelector('[data-copy-label]');
        const original = label.textContent;
        label.textContent = 'Copied!';
        label.classList.add('copied');
        setTimeout(function () {
          label.textContent = original;
          label.classList.remove('copied');
        }, 1500);
      });
    });
  });
});